import React from "react";

import { Users, UserPlus, UserCheck, UserX } from "lucide-react";
import Card, { CardBody } from "../../../components/bootstrap/Card";

interface Candidate {
    status: string;
}

interface Props {
    allCandidate: Candidate[];
}

const AppliedCandidatesStatus: React.FC<Props> = ({ allCandidate }) => {
    return (
        <CardBody>
            <div
                className="d-flex justify-content-center align-items-center gap-4 flex-nowrap px-3 py-3"
                style={{ overflowX: "auto" }}
            >
                {/* Total Candidates */}
                <Card className="bg-dark" style={{ height: "90px", width: "400px", border: "2px solid #2d3a56" }} shadow="sm">
                    <CardBody className="p-4">
                        <div className="d-flex justify-content-center align-items-center gap-2">
                            <Users className="text-purple" style={{ height: "24px", width: "24px" }} />
                            <div>
                                <div className="text-small text-purple">Total Candidates</div>
                                <div className="fw-bold fs-4 text-start">{allCandidate.length}</div>
                            </div>
                        </div>
                    </CardBody>
                </Card>

                {/* Applied */}
                <Card className="bg-dark" style={{ height: "90px", width: "400px", border: "2px solid #2d3a56" }} shadow="sm">
                    <CardBody className="p-4">
                        <div className="d-flex justify-content-center align-items-center gap-2">
                            <UserPlus className="text-primary" style={{ height: "24px", width: "24px" }} />
                            <div>
                                <div className="text-small text-primary">Applied</div>
                                <div className="fw-bold fs-4 text-start">
                                    {allCandidate.filter((item) => item.status === "applied").length}
                                </div>
                            </div>
                        </div>
                    </CardBody>
                </Card>

                {/* Shortlisted */}
                <Card className="bg-dark" style={{ height: "90px", width: "400px", border: "2px solid #2d3a56" }} shadow="sm">
                    <CardBody className="p-4">
                        <div className="d-flex justify-content-center align-items-center gap-2">
                            <UserCheck className="text-success" style={{ height: "24px", width: "24px" }} />
                            <div>
                                <div className="text-small text-success">Shortlisted</div>
                                <div className="fw-bold fs-4 text-start">
                                    {allCandidate.filter((item) => item.status === "shortlisted").length}
                                </div>
                            </div>
                        </div>
                    </CardBody>
                </Card>

                {/* Rejected */}
                <Card className="bg-dark" style={{ height: "90px", width: "400px", border: "2px solid #2d3a56" }} shadow="sm">
                    <CardBody className="p-4">
                        <div className="d-flex justify-content-center align-items-center gap-2">
                            <UserX className="text-danger" style={{ height: "24px", width: "24px" }} />
                            <div>
                                <div className="text-small text-danger">Rejected</div>
                                <div className="fw-bold fs-4 text-start">
                                    {allCandidate.filter((item) => item.status === "not_shortlisted" || item.status === "rejected").length}
                                </div>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </div>
        </CardBody>
    );
};

export default AppliedCandidatesStatus;
